<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
      single-expand
      :expanded.sync="expanded"
      item-key="zug_id"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template #[`item.obj_busena`]="{ item }">
        <el-hipoteka-busena :busena="item.obj_busena" />
      </template>
      <template #[`item.busenu_istorija`]="{ item }">
        <el-switch
          class="mt-0 mb-2"
          v-if="item.canBusenuIstorija"
          v-model="item.expandedBusena"
          @click.native="changeExpandedBusena(item)"
        />
      </template>
      <template #[`item.duomenu_istorija`]="{ item }">
        <el-switch
          class="mt-0 mb-2"
          v-if="item.isDuomenuIstorija"
          v-model="item.expandedDuomenys"
          @click.native="changeExpandedDuomenys(item)"
        />
      </template>
      <template #[`item.dokumentai`]="{ item }">
        <div class="nowrap">
          <el-byla
            :class="byla.class"
            v-for="byla in item.byla_perziura"
            :key="byla.byl_id"
            :byla="byla"
            :withName="byla.withName"
            in-line
          />
        </div>
        <div class="nowrap">
          <el-byla
            v-for="byla in item.perduota"
            :key="byla.byl_id"
            :byla="byla"
            color="primary"
            :with-name="byla.withName"
            in-line
            :class="byla.class"
          />
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
        />
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <istorija-busena
            v-if="item.expandedBusena"
            :obj-id="item.obj_id"
            :key="`busena-${item.zug_id}`"
          />
          <istorija-duomenys
            v-if="item.expandedDuomenys"
            :obj-id="item.obj_id"
            :key="`duomenys-${item.zug_id}`"
          />
        </td>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../../mixins/math'
import userRole from '../../../mixins/userRole'
import busena from '../../../mixins/busena'
import notKurejas from '../../../mixins/notKurejas'
import HipotekaMap from '../hipotekaMap'
import IstorijaBusena from '../istorija/IstorijaBusena'
import IstorijaDuomenys from '../istorija/IstorijaDuomenys'

export default {
  name: 'HipotekaPerduoti',
  components: {
    IstorijaBusena,
    IstorijaDuomenys,
  },
  mixins: [userRole, busena, math, notKurejas],
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      pranesimai: [],
      expanded: [],
      itemsPerPageOptions: [5, 10, 50, -1],
      pageSize: 5,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'appSavitarna']),
    headers() {
      return [
        {
          text: 'Duomenų teikėjo dokumento numeris',
          align: 'start',
          value: 'obj_dokumento_numeris',
        },
        {
          text: 'Pranešimo rūšis',
          align: 'start',
          value: 'hipotekaTipas',
        },
        {
          text: 'Pranešimo veiksmas',
          align: 'start',
          value: 'hipoteka_veiksmas',
        },
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          value: 'obj_identifikavimo_kodas',
        },
        {
          text: 'Gavimo data ir laikas',
          align: 'start',
          value: 'obj_perdavimo_data',
        },
        {
          text: 'Būsena',
          align: 'center',
          value: 'obj_busena',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          value: 'obj_busenos_data',
        },
        {
          text: 'Dokumentai',
          align: 'start',
          sortable: false,
          value: 'dokumentai',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: 'Veiksmų istorija',
          align: 'start',
          value: 'busenu_istorija',
        },
        {
          text: 'Duomenų istorija',
          align: 'start',
          value: 'duomenu_istorija',
          hide: !this.showDuomenuIstorija,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.pranesimai.map(item => {
        item.hipotekaTipas = HipotekaMap['hipotekaTipas'][item.obj_tipas]
          ? HipotekaMap['hipotekaTipas'][item.obj_tipas].title
          : item.obj_tipas

        item.hipoteka_veiksmas =
          item.obj_veiksmas === 1 ? 'Sudarymas' : 'Teikimas'

        if (item.obj_busena === 'rengiamas') {
          item.obj_perdavimo_data = null
        }

        item.notKurejas = !item.yra_kurejas

        item.canBusenuIstorija = !this.isSavitarna || item.obj_sistema === 2

        item.canEdit =
          (item.obj_busena === 'rengiamas' ||
            item.obj_busena === 'grazintas') &&
          item.obj_id != this.objektasID
        item.canView = !item.canEdit && item.obj_id != this.objektasID

        item.isDuomenuIstorija =
          item.obj_busena !== 'rengiamas' && item.obj_busena !== 'grazintas'

        if (
          item.obj_busena === 'rengiamas' ||
          item.obj_busena === 'grazintas'
        ) {
          item.byla_perziura = item.perziura.map((tipas, index) => {
            let tipasUrl = ''
            if (tipas === 'savitarna_pran' || tipas === 'preview_pran') {
              tipasUrl = 'pranesimas'
            }
            if (tipas === 'savitarna_dok' || tipas === 'preview_dok') {
              tipasUrl = 'dokumentas'
            }
            if (tipas === 'preview_word') {
              tipasUrl = 'word'
            }
            return {
              byl_id: `${item.obj_id}-${tipas}`,
              byl_sugeneruota: true,
              byl_tipas: tipas,
              byl_url: `objektas/${item.obj_id}/perziura/${tipasUrl}`,
              obj_dokumento_numeris: item.obj_dokumento_numeris,
              obj_tipas: item.obj_tipas,
              pranesimas_numeris: item.zug_numeris,
              notKurejas: item.notKurejas,
              withName: this.isSavitarna,
              class: this.isSavitarna ? 'bylaWithName' : '',
            }
          })
        } else {
          item.byla_perziura = []
        }
        item.perduota = item.perduota.map(byla => {
          return {
            ...byla,
            byl_url: `byla/${byla.byl_id}/${byla.byl_hash}/content`,
            obj_dokumento_numeris: item.obj_dokumento_numeris,
            obj_tipas: item.obj_tipas,
            pranesimas_numeris: item.zug_numeris,
            notKurejas: item.notKurejas,
            withName: this.isSavitarna,
            class: this.isSavitarna ? 'bylaWithName' : '',
          }
        })

        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 5
    },
    showDuomenuIstorija() {
      return this.roleRG
    },
    isSavitarna() {
      return this.appSavitarna
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/perduotipranesimai`)
        .then(res => {
          this.pranesimai = res.data.pranesimai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    editItem(item) {
      if (item.notKurejas) {
        this.notKurejas()
      } else {
        const objektasID = item.obj_id
        this.$store.dispatch('objektasID', objektasID)
        this.$store.dispatch('hipotekaTipas', item.obj_tipas)
        this.$root.$emit('reloadHipotekaTab')
        this.$router.push({
          name: 'hipotekaRegistravimas',
          params: {
            objektasID: objektasID,
          },
        })
      }
    },
    clearExpanded(item) {
      this.pranesimai.forEach(e => {
        if (e.zug_id != item.zug_id) {
          e.expandedBusena = false
          e.expandedDuomenys = false
        }
      })
    },
    changeExpandedBusena(item) {
      this.clearExpanded(item)
      item.expandedDuomenys = false

      if (item.notKurejas) {
        item.expandedBusena = false
        this.notKurejas()
      } else {
        if (item.expandedBusena) {
          this.expanded = [item]
        } else {
          this.expanded = []
        }
      }
    },
    changeExpandedDuomenys(item) {
      this.clearExpanded(item)
      item.expandedBusena = false

      if (item.notKurejas) {
        item.expandedDuomenys = false
        this.notKurejas()
      } else {
        if (item.expandedDuomenys) {
          this.expanded = [item]
        } else {
          this.expanded = []
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.bylaWithName {
  display: block;
}
</style>
